import { render, staticRenderFns } from "./secFaq.vue?vue&type=template&id=c1f6957c&"
import script from "./secFaq.vue?vue&type=script&lang=js&"
export * from "./secFaq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports